import {Feature} from "../../types/dto/Feature";
import {Translation} from "../../types/dto/Translation";

interface Subscription {
    abonnement: PackageType;
    price: number;
    text: {
        nl: string;
        fr: string;
        en: string;
    }
}

interface Package {
    abonnement: Subscription;
    totalPrice: number;
    addOns: AddOn[];
}

interface AddOn {
    feature: Feature;
    price: number;
    amount: number;
    text: Translation;
}
interface ISelectCountry {
    code: string;
    name: string;
}
interface PaymentMethod {
    id: string;
    description: string;
    image: {
        size1x: string;
        size2x: string;
        svg: string;
    }
}

enum PackageType {
    TRIAL = "trial",
    BASIC = "basic",
    STANDARD = "standard",
    PREMIUM = "premium",
    INSTITUTE_PREMIUM = "institute-premium",
    LIZAPREMIUM ="liza-premium"
}

enum CheckoutPage {
    SUBSCRIPTION = "subscription",
    CUSTOMER_DETAILS = "customer-details",
    PAYMENT = "payment"
}

interface CustomerDetailsForm {
    firstName: string | null;
    lastName: string | null;
    registrationNumber: string | null;
    vatNumber: string | null;
    phone: string | null;
    email: string | null;
    message: string;
}

export {
    Package,
    PackageType,
    AddOn,
    CheckoutPage,
    CustomerDetailsForm,
    PaymentMethod,
    ISelectCountry,
    Subscription
}